import { useEffect } from 'preact/hooks';
import { html } from '@shared/utils/rendering/html';
import { useAuth } from '../context/auth-context';
import { AuthConstants } from '../../constants/auth/auth.constants';

export default function withAuthGuard(Wrapped) {
    const Guard = (props) => {
        const context = useAuth();

        if (!context) {
            console.error('[auth] AuthProvider is NOT mounted above this route.');
            return html`<div class="error-page">
                <strong>Auth wiring error:</strong> AuthProvider is not mounted above this route.
            </div>`;
        }

        const { ready, isAuthenticated, login } = context;

        useEffect(() => {
            AuthConstants.Debug &&
                console.debug('[auth-guard] ready:', ready, 'isAuthenticated:', isAuthenticated);
            if (ready && !isAuthenticated) {
                const returnUrl = location.pathname + location.search + location.hash;
                login(returnUrl);
            }
        }, [ready, isAuthenticated]);

        if (!ready) {
            return html`
                <div class="authenticating p-4">
                    <h2 class="mb-2">Authenticating your session...</h2>
                    <p>We are just verifying who you are, this should not take long.</p>
                </div>
            `;
        }

        if (!isAuthenticated) {
            return html`
                <div class="redirecting p-4">
                    <h2 class="mb-2">Redirecting you to the sign in page</h2>
                    <p>Please wait a moment...</p>
                </div>
            `;
        }

        return html`<${Wrapped} ...${props} />`;
    };

    Guard.displayName = `WithAuthGuard(${Wrapped.displayName || Wrapped.name || 'Component'})`;
    return Guard;
}
